import React from 'react'
import BasePage from '../base'
import { css } from 'aphrodite'
import {
    deepCopyObject, getRoleLabel, getRoleValue,
    getUserId,
    getUserNameShow,
    getValueFromObjectByKeys,
    MESSAGE_TYPE,
    messageManager,
    myLog,
    renderCountries,
    renderCountriesPhoneCode,
    renderStates,
    translate
} from '../../helper'
import TextBase from '../../common/text'
import { Colors } from '../../themes/Colors'
import { userKey } from '../../utils/defined'
import { connect } from 'react-redux'
import withNavigate from '../../component/WithNavigate'
import { Col, Popover, Row } from 'antd'
import { SVGImageComponentReact } from '../../themes/Images'
import LoginInput from '../../common/login-input'
import ButtonGradient from '../../common/button-gradient'
import { UserAction } from '../../redux/action'
import SelectCustom from '../../common/select-custom'
import DefaultAvatar from '../../assets/image/default-avatar.png'
import OTPModal from '../../component/OTPModal'
import { styles } from './style'
import ImageZoom from '../../common/image-zoom'
import 'react-image-crop/dist/ReactCrop.css'
import Modal from '@mui/material/Modal'
import ImageEditor from '../../common/ImageCropModal'
import { IconButton } from '@mui/material'
import { resolveCssVarValue } from '../../utils/CommonFunction'
import Switch from 'react-switch'
import CustomSpinner from '../../common/CustomSpinner'

const menuKey = {
    legal: 'legal',
    policy: 'policy',
    agreement: 'agreement',
    note: 'note'
}

class AccountSettings extends BasePage {
    constructor(props) {
        super(props)
        this.title = 'Settings'
        this.state = {
            isTeamMember: true,
            userPhoneFormatValid: false,
            showOTP: false,
            showOTPUser: false,
            showOTPPopOver: false,
            showOTPUserPopOver: false,
            menuSelected: menuKey.policy,
            firstName: '',
            lastName: '',
            [userKey.firstName]: '',
            [userKey.lastName]: '',
            [userKey.email]: '',

            name: '',
            avatar: '',
            loadingUpdateData: false,
            profileImageFile: null,
            previewImage: '',
            description: '',
            businessEmail: '',
            phoneNumber: '',
            phoneNumberPrev: '',
            businessName: '',
            taxID: '',
            country: '',
            userPhoneCode: '',
            userPhoneCodePrev: '',
            phoneCode: '',
            phoneCodePrev: '',
            state: '',
            city: '',
            zip: '',
            address: '',
            notificationEmail: false,
            notificationSms: false,
            dealerImageFile: null,
            previewDealerImage: '',
            dealerAvatar: '',
            phoneVerified: false,
            phoneFormatValid: false,
            email: '',
            role: '',
            userPhone: '',
            userPhonePrev: '',
            userPhoneVerified: false,
            domainName: '',
            manageBranding: false,
            customDomain: false,
            logoImage: null,
            isEditorOpen: false,
            logoImage2: null,
            isEditorOpen2: false,
            emailSwitchSize: {
                height: resolveCssVarValue('--fs-xl') * 1.037735,
                width: resolveCssVarValue('--fs-hero') * 1.037735,
                handleDiameter: resolveCssVarValue('--fs-xs') * 1.6981132
            },
            smsSwitchSize: {
                height: resolveCssVarValue('--fs-xl') * 1.037735,
                width: resolveCssVarValue('--fs-hero') * 1.037735,
                handleDiameter: resolveCssVarValue('--fs-xs') * 1.6981132
            }
        }
        this.cacheUserInfo = {}
    }

    _componentDidMount = async () => {
        this.fetchData()
        const handleResize = () => {
            this.setState({
                emailSwitchSize: {
                    height: resolveCssVarValue('--fs-xl') * 1.037735,
                    width: resolveCssVarValue('--fs-hero') * 1.037735,
                    handleDiameter: resolveCssVarValue('--fs-xs') * 1.6981132
                },
                smsSwitchSize: {
                    height: resolveCssVarValue('--fs-xl') * 1.037735,
                    width: resolveCssVarValue('--fs-hero') * 1.037735,
                    handleDiameter: resolveCssVarValue('--fs-xs') * 1.6981132
                }
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }

    handleCancel = () => {
        this.fetchData()
    }

    fetchData = async () => {
        try {
            this.setState({
                loadingUpdateData: true
            })
            const { getUserProfile, getVendorProfile, userInfo, getVendor } = this.props

            const userId = getValueFromObjectByKeys(userInfo, ['user', 'id'])

            try {
                const resProfile = await getUserProfile(getUserId(userInfo))
                const resVendorProfile = await getVendorProfile(getUserId(userInfo))

                const userData = getValueFromObjectByKeys(resProfile, ['data'])
                const vendorData = getValueFromObjectByKeys(resVendorProfile, ['data'])
                this.saveDataUser(userData)
                this.setUserData({ ...userData })

                this.setVendorData(vendorData)
                this.setState({
                    loadingUpdateData: false
                })
            } catch (e) {
                this.setState({
                    loading: false,
                    loadingUpdateData: false
                })

            }
        } catch (error) {
            myLog('_componentDidMount Profile', error)
        }
    }

    onPhoneCodeSelect = (key, value) => {

        this.setState({
            [key]: value
        })
    }

    onCountrySelect = (value) => {
        if (value !== 'US' || value !== 'CA') {
            this.setState({ state: undefined })
        }
        this.setState({
            country: value
        })
    }
    handleState = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    onStateSelect = (value) => {
        this.setState({
            state: value
        })
    }

    setVendorData = (dealerData) => {
        this.setState({
            vendorId: dealerData.id,
            description: dealerData.description,
            businessEmail: dealerData.business_email,
            phoneNumber: dealerData.phone_number.national_number,
            phoneCode: dealerData.phone_number.country_code || '1',
            phoneNumberPrev: dealerData.phone_number.national_number,
            phoneCodePrev: dealerData.phone_number.country_code || '1',
            businessName: dealerData.business_name,
            taxID: dealerData.tax_id,
            country: dealerData.country,
            state: dealerData.state,
            city: dealerData.city,
            zip: dealerData.zip,
            address: dealerData.address,
            phoneVerified: dealerData.phone_verified,
            dealerAvatar: dealerData?.logo
        })
    }

    setUserData = (userData) => {
        this.setState({
            isTeamMember: userData?.team_member,
            firstName: userData?.user?.first_name,
            lastName: userData?.user?.last_name,
            role: userData?.user?.group?.name,
            email: userData?.user?.email,
            userPhone: userData?.phone_number?.national_number,
            userPhoneCode: userData?.phone_number?.country_code || '1',
            userPhonePrev: userData?.phone_number?.national_number,
            userPhoneCodePrev: userData?.phone_number?.country_code || '1',
            userPhoneVerified: userData?.phone_verified,
            notificationEmail: userData?.notification_email,
            notificationSms: userData?.notification_sms,
            domainName: userData?.domain_configuration?.domain_name,
            manageBranding: userData?.manage_branding,
            customDomain: userData?.custom_domain,
        })
    }

    saveDataUser = (userData = {}) => {
        const { userInfo } = this.props
        this.cacheUserInfo = {
            avatar: userData[userKey.profile_image],
            name: getUserNameShow(userInfo)
        }
        this.setState({
            userInfo: deepCopyObject(this.cacheUserInfo),
            avatar: userData[userKey.profile_image],
            name: getUserNameShow(userInfo),
            profileImageFile: null,
            previewImage: ''
        })
    }

    updateProfile = async () => {
        const {
            firstName,
            lastName,
            userPhone,
            userPhoneCode,
            phoneCode,
            email,
            role,
            description,
            businessEmail,
            phoneNumber,
            businessName,
            taxID,
            country,
            state,
            city,
            zip,
            address,
            notificationEmail,
            notificationSms,
            isTeamMember,
        } = this.state

        const { updateProfile, userInfo, vendor, updateVendor } = this.props
        const {
            avatar,
            previewImage,
            profileImageFile,
            dealerImageFile,
            previewDealerImage,
            dealerAvatar
        } = this.state

        if (previewImage && profileImageFile) {
            let formData = new FormData()
            formData.append([userKey.profile_image], profileImageFile)
            const resNewData = await updateProfile(formData, getUserId(userInfo))
        }

        if (previewDealerImage && dealerImageFile) {
            let formData = new FormData()
            formData.append('logo', dealerImageFile)
            const resUpdateVendor = await updateVendor(formData, this.state.vendorId)
        }

        if (true) {
            this.setState({
                loadingUpdateData: true
            })

            try {
                let formData = {
                    notification_email: notificationEmail,
                    notification_sms: notificationSms,
                    role: getRoleValue(role),
                    user: {
                        first_name: this.state.firstName,
                        last_name: this.state.lastName,
                        email,
                    },
                    domain: {
                        domain_name: this.state.domainName,
                    },
                }
                if (userPhone) {
                    formData = {
                        ...formData,
                        phone_number: { national_number: userPhone, country_code: userPhoneCode }
                    }
                }

                let vendorFormData = {
                    full_name: `${firstName} ${lastName}`,
                    description,
                    business_email: businessEmail,
                    business_name: businessName,
                    tax_id: taxID,
                    country,
                    city,
                    zip,
                    address,
                }

                if (phoneNumber) {
                    vendorFormData = {
                        ...vendorFormData,
                        phone_number: { national_number: phoneNumber, country_code: phoneCode }
                    }
                }
                if (state) {
                    vendorFormData.state = state
                }

                const resNewData = await updateProfile(formData, getUserId(userInfo), false)
                if (resNewData) {
                    messageManager({
                        type: MESSAGE_TYPE.success,
                        messageShow: 'Updated Successfully.'
                    })
                    this.setState({
                        loadingUpdateData: false
                    })
                    const userData = getValueFromObjectByKeys(resNewData, ['data'])
                    this.saveDataUser(userData)
                    this.setUserData({ ...userData })
                }

                const userData = getValueFromObjectByKeys(resNewData, ['data'])

            } catch (error) {
                messageManager({
                    type: MESSAGE_TYPE.error,
                    messageShow: error?.error || 'Update Failed.'
                })
                this.setState({
                    loadingUpdateData: false
                })
            }
        }
    }

    onReceiveByEmail = () => {
        this.setState({ notificationEmail: !this.state.notificationEmail })
    }

    onReceiveBySMS = () => {
        if (this.state.userPhoneVerified) {
            this.setState({ notificationSms: !this.state.notificationSms })
        } else {
            this.setState({ notificationSms: false })
            messageManager({
                messageShow: 'Please verify your mobile number',
                type: MESSAGE_TYPE.warning
            })
        }
    }

    getSMSCodeForUser = async () => {
        const { sendSMSUser } = this.props
        const { userPhoneCode, userPhone, userPhonePrev } = this.state
        try {

            if (userPhonePrev !== userPhone) {
                this.setState({
                    showOTPUserPopOver: true
                })
                setTimeout(() => {
                    this.setState({
                        showOTPUserPopOver: false
                    })
                }, 3000)
                return
            }

            await sendSMSUser({
                phone_number: `+${userPhoneCode}${userPhone}`
            })
            this.setState({
                showOTPUser: true
            })
        } catch (error) {

            alert(error?.error)
            this.setState({
                showOTPUser: false
            })
        }
    }

    getSMSCode = async () => {
        const { sendSMS } = this.props

        const { phoneNumber, phoneNumberPrev, phoneCode } = this.state

        if (phoneNumberPrev !== phoneNumber) {
            this.setState({
                showOTPPopOver: true
            })
            setTimeout(() => {
                this.setState({
                    showOTPPopOver: false
                })
            }, 3000)
            return
        }

        try {
            await sendSMS({
                phone_number: `+${phoneCode}${phoneNumber}`
            })
            this.setState({
                showOTP: true
            })
        } catch (error) {

            this.setState({
                showOTP: false
            })
        }
    }

    closeModal = () => {
        this.setState({
            showOTP: false,
            showOTPUser: false
        })
    }

    onFileUpload = (e) => {
        const file = e.target.files[0]
        this.setState({ logoImage: file, isEditorOpen: true })
    }
    onFileUpload2 = (e) => {
        const file = e.target.files[0]
        this.setState({ logoImage2: file, isEditorOpen2: true })
    }

    imageUrl(url) {
        if (url?.type) {
            return URL.createObjectURL(url)
        }
        return url
    }

    handleCloseEditor = () => {
        let input = document.getElementById('myFile')
        if (input) {
            input.value = ''
        }
        this.setState({ logoImage: null, isEditorOpen: false })
    }

    handleCloseEditor2 = () => {
        let input = document.getElementById('myFile2')
        if (input) {
            input.value = ''
        }
        this.setState({ logoImage2: null, isEditorOpen2: false })
    }

    handleCroppedImage = (img) => {
        let arr = img.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }

        let file = new File([u8arr], this.state.logoImage.name, { type: mime })
        this.setState({ isEditorOpen: false, profileImageFile: file, previewImage: file })
        this.handleCloseEditor()
    }

    handleCroppedImage2 = (img) => {
        let arr = img.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }

        let file = new File([u8arr], this.state.logoImage2.name, { type: mime })
        this.setState({ isEditorOpen2: false, dealerImageFile: file, previewDealerImage: file })
        this.handleCloseEditor2()
    }

    renderContent() {
        const { navigate, userInfo } = this.props
        const {
            firstName,
            lastName,
            description,
            businessEmail,
            phoneNumber,
            businessName,
            taxID,
            country,
            phoneCode,
            userPhoneCode,
            state,
            city,
            zip,
            address,
            notificationEmail,
            notificationSms,
            name,
            avatar,
            loadingUpdateData,
            previewImage,
            profileImageFile,
            previewDealerImage,
            dealerImageFile,
            dealerAvatar,
            phoneFormatValid,
            role,
            userPhone,
            domainName,
            manageBranding,
            customDomain
        } = this.state

        return (
            <div className={css(styles.container)}>
                <div className="flex-row-center">
                    <IconButton onClick={() => navigate(-1)} style={{ paddingTop: '0', paddingBottom: '0', paddingLeft: 0 }}>
                        <SVGImageComponentReact.IconArrowBack style={{ marginRight: 'var(--sp-md2)', width: "var(--fs-lg)", height: "var(--fs-lg)", color: '#1A5A78' }} />
                    </IconButton>
                    <span style={{
                        fontSize: 'calc(var(--fs-xl) * 1.50943)',
                        fontWeight: 700,
                        color: '#1A5A78'
                    }}>
                        {translate('myProfile')}
                    </span>
                </div>
                <Row
                    align="center"
                    justify="center"
                    style={{ marginTop: 'calc(var(--sp-lg)*1.79245)' }}
                    gutter={[25]}>
                    <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={18}
                        style={{ paddingRight: 'calc(var(--sp-lg)*1.179245)' }}
                        span={16}>
                        <div
                            style={{
                                padding: 'calc(var(--sp-lg)*1.509433)',
                                backgroundColor: Colors.white,
                                borderRadius: 'var(--sp-md2)',
                                boxShadow: `0px 1px 2px 1px rgba(0, 0, 0, 0.05)`
                            }}>
                            <div className={css(styles.header)}>
                                <TextBase
                                    style={{ marginBottom: 'calc(var(--sp-lg)*1.037735)' }}
                                    size='calc(var(--fs-xs) * 1.698113)'
                                    color={Colors.gray2}>
                                    personalInformation
                                </TextBase>
                                <div className={css(styles.divider)} />
                            </div>

                            <Row gutter={[30]}>
                                {/* First Name */}
                                <Col span={24}>
                                    <div
                                        style={{
                                            width: "calc(var(--fs-hero)*3)",
                                            height: "calc(var(--fs-hero)*3)",
                                            borderRadius: "50%",
                                            backgroundColor: "#fff",
                                            marginBottom: "calc(var(--sp-lg)*1)",
                                            border: "1px solid rgba(0,0,0,0.06)",
                                            boxShadow: `inset 0 1px 1px rgba(255,255,255,0.9), inset 0 -0.5px 1px rgba(0,0,0,0.04), 0 0 0 1px rgba(0,0,0,0.02),
                                                        0 0 0 2.5px rgba(0,0,0,0.03), 0 2px 7px rgba(0,0,0,0.05), 0 8px 22px rgba(0,0,0,0.06)`,
                                            padding: "calc(var(--sp-sm)*0.8490566)",
                                            position: "relative",
                                            cursor: "pointer",
                                            transition: 'all 200ms ease',
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 1000
                                        }}
                                        onMouseOver={e => e.currentTarget.style.transform = 'scale(1.1)'}
                                        onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}>
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                borderRadius: 'calc(var(--sp-lg)*6.556603)',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            {previewImage || avatar ? (
                                                <ImageZoom
                                                    imageSrc={previewImage && profileImageFile ? previewImage : avatar}
                                                    altSrc={previewImage && profileImageFile ? previewImage : avatar}
                                                >
                                                    <img
                                                        src={previewImage && profileImageFile ? this.imageUrl(previewImage) : avatar}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            borderRadius: 'calc(var(--sp-lg)*6.556603)',
                                                            objectFit: 'fill',
                                                            objectPosition: 'center',
                                                            backgroundColor: Colors.white,
                                                            display: 'block'
                                                        }}
                                                    />
                                                </ImageZoom>
                                            ) : (
                                                <ImageZoom
                                                    imageSrc={DefaultAvatar}
                                                    altSrc={DefaultAvatar}
                                                >
                                                    <img
                                                        src={DefaultAvatar}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            borderRadius: 'calc(var(--sp-lg)*6.556603)',
                                                            objectFit: 'contain',
                                                            objectPosition: 'center',
                                                            backgroundColor: Colors.white,
                                                            display: 'block'
                                                        }}
                                                    />
                                                </ImageZoom>
                                            )}
                                        </div>

                                        <div
                                            onClick={() => document.getElementById('profile-upload')?.click()}
                                            role="button"
                                            style={{
                                                position: 'absolute',
                                                right: 'calc(var(--fs-xs)*-1)',
                                                top: 'calc(var(--fs-xl)*3.30188)',
                                                width: 'calc(var(--fs-xl)*1.4150943)',
                                                height: 'calc(var(--fs-xl)*1.4150943)',
                                                borderRadius: '50%',
                                                border: `0.5px solid ${Colors.white}`,
                                                boxShadow: `0 4px 10px rgba(2, 17, 69, 0.12), 0 0 0 1px rgba(2, 17, 69, 0.06)`,
                                                backgroundColor: Colors.white,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <SVGImageComponentReact.IconEditPen
                                                style={{
                                                    width: 'calc(var(--fs-xs)*1.4150943)',
                                                    height: 'calc(var(--fs-xs)*1.4150943)',
                                                    display: 'block'
                                                }}
                                            />
                                        </div>

                                        <input
                                            id="profile-upload"
                                            type="file"
                                            onChange={this.onFileUpload}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div>
                                        <TextBase size={'calc(var(--fs-xs)*1.50943)'} fontWeight={400} color={Colors.black}>
                                            firstName
                                        </TextBase>
                                        <LoginInput
                                            value={firstName}
                                            placeholder="enterFirstName"
                                            className="width-100"
                                            style={{
                                                width: '100%',
                                                marginTop: 'var(--sp-sm)',
                                                fontSize: 'calc(var(--fs-xs)*1.50943)',
                                                paddingLeft: 'calc(var(--sp-md2)*1.50943)'
                                            }}
                                            onChange={(val) => this.handleState('firstName', val)}
                                        />
                                    </div>
                                </Col>

                                <Col span={12}>
                                    <div>
                                        <TextBase size={'calc(var(--fs-xs)*1.50943)'} fontWeight={400} color={Colors.black}>
                                            lastName
                                        </TextBase>
                                        <LoginInput
                                            value={lastName}
                                            placeholder="enterLastName"
                                            className="width-100"
                                            style={{
                                                width: '100%',
                                                marginTop: 'var(--sp-sm)',
                                                fontSize: 'calc(var(--fs-xs)*1.50943)',
                                                paddingLeft: 'calc(var(--sp-md2)*1.50943)',
                                                color: Colors.black,
                                                backgroundColor: Colors.white
                                            }}
                                            onChange={(val) => this.handleState('lastName', val)}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={30}>
                                <Col xxl={12} span={24} style={{ marginTop: 'calc(var(--sp-md2)*1.88679)' }}>
                                    <div>
                                        <TextBase
                                            style={{ textAlign: 'left' }}
                                            className="ellipsis"
                                            size={'calc(var(--fs-xs)*1.50943)'}
                                            color={Colors.black}>
                                            email
                                        </TextBase>
                                        <LoginInput
                                            value={this.state.email}
                                            onChange={(val) => this.handleState('email', val)}
                                            placeholder="enterEmail"
                                            noPaddingRight={true}
                                            rightElement={
                                                <ButtonGradient
                                                    textStyle={{ fontWeight: 600, fontSize: 'calc(var(--fs-xs)*1.60377)' }}
                                                    title="verified"
                                                    backgroundColor="#10B981"
                                                    disabled
                                                    style={{
                                                        padding: 'calc(var(--sp-md2)*1.88679)',
                                                        height: 'calc(var(--fs-hero)*1.179245)',
                                                        width: '100%',
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0,
                                                        boxShadow: '-2px 0px 2px 0px #4040400D'
                                                    }}
                                                    loading={loadingUpdateData}
                                                />
                                            }
                                        />
                                    </div>
                                </Col>

                                <Col xxl={12} span={24} style={{ marginTop: 'calc(var(--sp-md2)*1.88679)' }}>
                                    <div>
                                        <TextBase
                                            style={{ textAlign: 'left' }}
                                            className="ellipsis"
                                            size={'calc(var(--fs-xs)*1.50943)'}
                                            color={Colors.black}>
                                            mobileNumber
                                        </TextBase>

                                        <div style={{ display: 'flex' }}>
                                            <div style={{ minWidth: 'calc(var(--fs-hero)*3.533773)', zIndex: 2200 }}>
                                                <SelectCustom
                                                    className="full-width"
                                                    width='calc(var(--fs-hero)*8.13679)'
                                                    value={userPhoneCode}
                                                    placeholder="Select PhoneCode"
                                                    searchPlaceholder={translate('searchCountryPhoneCode')}
                                                    items={renderCountriesPhoneCode()}
                                                    onSelect={(val) => {
                                                        this.onPhoneCodeSelect('userPhoneCode', val)
                                                    }}
                                                    showSearch
                                                />
                                            </div>
                                            <div style={{ display: 'flex', width: '100%' }}>
                                                <div style={{ width: '100%', marginLeft: 'var(--sp-md2)' }}>
                                                    <LoginInput
                                                        value={userPhone}
                                                        onChange={(val) => this.handleState('userPhone', val)}
                                                        placeholder="enterMobile"
                                                        noPaddingRight={true}
                                                        rightElement={
                                                            <ButtonGradient
                                                                disabled={
                                                                    this.state.userPhoneVerified &&
                                                                    this.state.userPhone === this.state.userPhonePrev
                                                                }
                                                                className="verified-button"
                                                                onClick={() => this.getSMSCodeForUser()}
                                                                textStyle={{ fontWeight: 600, fontSize: 'calc(var(--fs-xs)*1.60377)' }}
                                                                title={
                                                                    this.state.userPhoneVerified &&
                                                                        this.state.userPhone === this.state.userPhonePrev
                                                                        ? 'verified'
                                                                        : 'verify'
                                                                }
                                                                backgroundColor={
                                                                    this.state.userPhoneVerified &&
                                                                        this.state.userPhone === this.state.userPhonePrev
                                                                        ? '#10B981'
                                                                        : this.state.userPhonePrev !== this.state.userPhone
                                                                            ? '#C8C8C8'
                                                                            : null
                                                                }
                                                                style={{
                                                                    padding: 'calc(var(--sp-md2)*1.88679)',
                                                                    height: 'calc(var(--fs-hero)*1.179245)',
                                                                    width: '100%',
                                                                    borderTopLeftRadius: 0,
                                                                    borderBottomLeftRadius: 0,
                                                                    boxShadow: '-2px 0px 2px 0px #4040400D'
                                                                }}
                                                                loading={loadingUpdateData}
                                                            />
                                                        }
                                                    />
                                                </div>
                                                <Popover
                                                    content="Update phone to verify"
                                                    visible={this.state.showOTPUserPopOver}
                                                    placement="topRight"
                                                    styles={{
                                                        body: {
                                                            color: 'red', 
                                                            fontSize: 'calc(var(--fs-xs)*1.32075)',
                                                            lineHeight: 'calc(var(--sp-md2)*1.88679)',
                                                        }
                                                    }}
                                                ></Popover>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={30} style={{ marginTop: 'calc(var(--sp-md2)*1.88679)' }}>
                                {/* Role */}
                                <Col span={12}>
                                    <div>
                                        <TextBase size={'calc(var(--fs-xs)*1.50943)'} fontWeight={400} color={Colors.black}>
                                            role
                                        </TextBase>
                                        <LoginInput
                                            value={getRoleLabel(role)}
                                            placeholder="enterRole"
                                            className="width-100"
                                            disabled
                                            style={{
                                                width: '100%',
                                                marginTop: 'var(--sp-sm)',
                                                fontSize: 'calc(var(--fs-xs)*1.50943)',
                                                paddingLeft: 'calc(var(--sp-md2)*1.50943)',
                                                color: Colors.black,
                                                cursor: 'not-allowed',
                                                backgroundColor: Colors.grey4
                                            }}
                                            onChange={(val) => this.handleState('role', val)}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div className={css(styles.header, styles.spacingMd)}>
                                <TextBase
                                    fontWeight={600}
                                    style={{ marginBottom: 'calc(var(--sp-lg)*1.037735)' }}
                                    size={'calc(var(--fs-xs)*1.698113)'}
                                    color={Colors.gray2}>
                                    notificationSettings
                                </TextBase>
                                <div className={css(styles.divider)} />
                            </div>

                            <Row>
                                <Col span={12}>
                                    <Row justify="space-between">
                                        <Row>
                                            <TextBase
                                                fontWeight={400}
                                                size={'calc(var(--fs-xs)*1.50943)'}
                                                style={{ marginRight: 'calc(var(--sp-md2)*1.50943)' }}
                                                color={Colors.black}>
                                                receiveByEmail
                                            </TextBase>

                                            {!loadingUpdateData && (
                                                <Switch
                                                    key={this.state.emailSwitchSize.handleDiameter}
                                                    checked={this.state.notificationEmail}
                                                    onColor={Colors.link}
                                                    offColor='#E5E7EB'
                                                    checkedHandleIcon={<div />}
                                                    inputMode="none"
                                                    height={this.state.emailSwitchSize.height}
                                                    width={this.state.emailSwitchSize.width}
                                                    handleDiameter={this.state.emailSwitchSize.handleDiameter}
                                                    onChange={this.onReceiveByEmail}
                                                    uncheckedIcon={<div />}
                                                    checkedIcon={<div />}
                                                />
                                            )}
                                        </Row>

                                        <Row>
                                            <TextBase
                                                fontWeight={400}
                                                size={'calc(var(--fs-xs)*1.50943)'}
                                                style={{ marginRight: 'calc(var(--sp-md2)*1.50943)' }}
                                                color={Colors.black}>
                                                receiveBySMS
                                            </TextBase>
                                            {!loadingUpdateData && (
                                                <Switch
                                                    key={this.state.smsSwitchSize.handleDiameter}
                                                    checked={this.state.notificationSms}
                                                    onColor={Colors.link}
                                                    offColor='#E5E7EB'
                                                    checkedHandleIcon={<div />}
                                                    inputMode="none"
                                                    height={this.state.smsSwitchSize.height}
                                                    width={this.state.smsSwitchSize.width}
                                                    handleDiameter={this.state.smsSwitchSize.handleDiameter}
                                                    onChange={this.onReceiveBySMS}
                                                    uncheckedIcon={<div />}
                                                    checkedIcon={<div />}
                                                />
                                            )}
                                        </Row>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col span={12}>
                                    <div
                                        className="flex-row-center-center cursor-pointer cancel-button"
                                        style={{ marginTop: 'calc(var(--sp-lg)*2.83018)', height: 'calc(var(--fs-hero)*1.32075)' }}>
                                        <TextBase
                                            onClick={this.handleCancel}
                                            size={'calc(var(--fs-xs)*1.50943)'}
                                            style={{ textAlign: 'center' }}
                                            color={Colors.grey}>
                                            cancel
                                        </TextBase>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="flex-row-center-all" style={{ marginTop: 'calc(var(--sp-lg)*2.83018)', height: 'calc(var(--fs-hero)*1.32075)' }}>
                                        <ButtonGradient
                                            onClick={this.updateProfile}
                                            textStyle={{ fontSize: 'calc(var(--fs-xs)*1.50943)' }}
                                            title="update"
                                            style={{ width: '100%' }}
                                            loading={loadingUpdateData}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                {loadingUpdateData && <CustomSpinner fullPage />}
                {/* User */}
                <OTPModal
                    type="user"
                    fetchData={this.fetchData}
                    getSMSCode={this.getSMSCodeForUser}
                    showOTP={this.state.showOTPUser}
                    phone={this.state.userPhone || ''}
                    phoneCode={this.state.userPhoneCode || ''}
                    closeModal={this.closeModal}
                />

                {/* Dealer */}
                <OTPModal
                    type="dealer"
                    fetchData={this.fetchData}
                    getSMSCode={this.getSMSCode}
                    showOTP={this.state.showOTP}
                    phoneCode={this.state.phoneCode || ''}
                    phone={this.state.phoneNumber || ''}
                    closeModal={this.closeModal}
                />

                <Modal open={this.state.isEditorOpen} onClose={this.handleCloseEditor}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            width: '60%',
                            minHeight: 'calc(var(--fs-hero)*9.433962)',
                            position: 'relative',
                            background: '#000',
                            padding: 'var(--sp-md2)'
                        }}>
                            <ImageEditor img={this.state.logoImage} setCroppedImage={this.handleCroppedImage}
                                handleCloseEditor={this.handleCloseEditor} />
                        </div>
                    </div>
                </Modal>

                <Modal open={this.state.isEditorOpen2} onClose={this.handleCloseEditor2}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            width: '60%',
                            minHeight: 'calc(var(--fs-hero)*9.433962)',
                            position: 'relative',
                            background: '#000',
                            padding: 'var(--sp-md2)'
                        }}>
                            <ImageEditor img={this.state.logoImage2} setCroppedImage={this.handleCroppedImage2}
                                handleCloseEditor={this.handleCloseEditor2} />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userDetail: getValueFromObjectByKeys(state, ['User', 'userDetail']),
        userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
        vendor: getValueFromObjectByKeys(state, ['User', 'vendor']),
        listNotification: getValueFromObjectByKeys(state, ['User', 'notification'])
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getUserProfile: (id) => {
            return dispatch(UserAction.getUserProfile(id))
        },
        getVendorProfile: (id) => {
            return dispatch(UserAction.getVendorProfile(id))
        },
        getVendor: (query) => {
            return dispatch(UserAction.getVendor(query))
        },
        updateProfile: (params, id, isFormData) => {
            return dispatch(UserAction.updateProfile(params, id, isFormData))
        },
        updateVendor: (params, id) => {
            return dispatch(UserAction.updateVendor(params, id))
        },
        sendSMS: (params, id) => {
            return dispatch(UserAction.sendSMS(params))
        },
        sendSMSUser: (params, id) => {
            return dispatch(UserAction.sendSMSUser(params))
        },
        verifyPhoneNumber: (params, id) => {
            return dispatch(UserAction.updateVendor(params, id))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withNavigate(AccountSettings))
